import { Profile, ProfileTier } from '@fcom/core-api/login';

/**
 * Checks if the user's profile tier is a Finnair Plus tier (basic, junior, silver, gold, platinum or lumo) or not (corporate or finnair account)
 * @param profile profile of the user
 * @returns boolean
 */
export const isAuthenticatedPlusMember = (profile: Profile): boolean =>
  Boolean(profile && profile.tier !== ProfileTier.CORPORATE && profile.tier !== ProfileTier.ACCOUNT);
